// extracted by mini-css-extract-plugin
export default {"hintContainer":"BankHintsWrapper_hintContainer__q0rc3"};